import React from 'react';
import { PartnerWithCredits } from 'us-react-components/dist/PartnerWithCredits/PartnerWithCredits';
import { CreditTransferResponse, PartnerCreditBalance } from 'us-web-services';
import { useDependencies } from '../../../../../dependencies';

export type PartnerName = 'Outschool' | 'ActivityHero';

interface Props {
  partner: PartnerName;
  partnerLogo: string;
  balance: PartnerCreditBalance|undefined;
  successfulTransfer: boolean;
  handleTransfer: (partner: PartnerName, amount: number) => Promise<CreditTransferResponse>;
}

export const PartnerCreditWidget = ({ partner, partnerLogo, balance, successfulTransfer, handleTransfer } : Props): JSX.Element => {
  const { services: { tracker } } = useDependencies();

  const trackEvent = async (event: string, params?: {elementText: string}): Promise<void> => tracker.track(event, params);

  return (
    <div className='pl-3.5 pr-3.5 place-content-center rounded-2xl border-2 group w-full h-full'>
      <PartnerWithCredits
        partner={partner}
        partnerLogo={partnerLogo}
        creditBalance={balance?.totalAvailable ?? 0}
        creditsTransferred={balance?.totalUsed ?? 0}
        successfulTransferInitialValue={successfulTransfer}
        transferCredits={handleTransfer}
        trackingCallback={trackEvent}
      />
    </div>
  );
};
